export default __webpack_public_path__ + "static/media/VotingCardC_SideB.b1b9022c.png";